export type UserInfoObject = {
  /* Users login id */
  loginId: string;
  /* Users first name */
  firstName: string;
  /* Users last name */
  lastName: string;
  /* Users email address */
  email: string;
  /* Users unique visitor id also unknown as oavistorId/mySPHw */
  visitorId: string;
  /* Users service flags eg: reg_bt, bt_all */
  serviceFlags: string[];
  /* Users registration status */
  userStatus: UserRegistrationStatusEnum;
};

export type SanitizedUserInfoObject = {
  /** User type based on services flags */
  userType: UserTypeEnum;
  /** Visitor category - numeric representation of user type */
  visitorcat: number;
  /** Display name - combination of first and last name or login id */
  displayName: string;
} & UserInfoObject;

export type FeedSSOUserDetailsResponse = {
  /** Users login id */
  loginId: string;
  /** Users first name */
  firstName: string;
  /** Users last name */
  lastName: string;
  /** Users email address */
  email: string;
  /** Users unique visitor id also unknown as oavistorId/mySPHw */
  visitorId: string;
  /** Users service flags eg: reg_bt, bt_all */
  serviceFlags: string[];
  /** Users registration status */
  userStatus: string;
};

export enum UserTypeEnum {
  SUBSCRIBER = "subscriber",
  REGISTERED = "registered",
  ANONYMOUS = "anonymous",
  GUEST = "guest",
  IAP_SUBSCRIBER = "iap_subscriber",
}

export enum UserRegistrationStatusEnum {
  VERIFIED = "verified",
  UNVERIFIED = "unverified",
}
